import * as React from 'react'
import styled from 'styled-components'
import * as constants from '../../../../static/constants'
import { Panel } from '../../../atoms'
import AgentNav from '../../../organisms/AgentNav'

interface IProps {
  model: string
  main: React.ReactElement
  title?: string | React.ReactElement
  hideAgentNav?: boolean
}

const AgentLayoutIndex: React.FC<IProps> = props => {
  return (
    <Wrapper>
      {!props.hideAgentNav && (
        <AgentSidebarWrapper>
          <AgentNav active={props.model} />
        </AgentSidebarWrapper>
      )}
      <section className="Index_Main">
        <Panel title={props.title}>{props.main}</Panel>
      </section>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  min-height: calc(100vh - ${constants.HEADER_HEIGHT + constants.FOOTER_HEIGHT}px);
  margin: 0 auto;
  background-color: ${constants.COLORS.background};
  @media (max-width: ${constants.BREAKPOINT_TABLET_LARGE}px) {
    display: block;
    height: auto;
    min-height: calc(100vh - ${constants.FOOTER_HEIGHT}px);
    padding-top: 55px;
  }

  .Index_Main {
    width: 100%;
    height: 100%;
    max-width: 1340px;
    min-width: 0;
    margin: 0 auto;
    padding: 22px 40px 80px 46px;

    @media (max-width: ${constants.BREAKPOINT_DESKTOP}px) {
      padding: 16px 12px;
      margin: 0 auto;
    }
  }

  .Panel {
    max-width: none;
  }
`

const AgentSidebarWrapper = styled.div`
  margin-top: 20px;
  @media (max-width: ${constants.BREAKPOINT_TABLET_LARGE}px) {
    margin-top: 0px;
  }
`

export default AgentLayoutIndex
